import { intercomBootProps, INTERCOM_INITIALIZATION_DELAY, canBootIntercom } from "components/common/utils/IntercomWrapper"
import { useEffect } from "react";
import { useIntercom } from "react-use-intercom"

const useCharlesIntercom = (showIntercom) => {
  const { boot, shutdown } = useIntercom();
  useEffect(() => {
    if(!showIntercom){
      shutdown()
    }
    setTimeout(() => {
      if(canBootIntercom() && showIntercom){
        boot(intercomBootProps)
      }
      else {
        shutdown()
      }
    }, INTERCOM_INITIALIZATION_DELAY)
  }, []);

}

export default useCharlesIntercom